import { useEffect, useRef } from 'react';

export const usePrevious = <Value>(value: Value): Value => {
	const ref = useRef<Value>(value);
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
};
